import { useState, useEffect } from 'react';
import { Dialog, Card } from '@mui/material';
import { icons } from "../../helpers/constants";
import { useTranslation } from "react-i18next";
import Button from '../Buttons/Button';
import { useIsMobile } from '../../helpers/customHooks';
import * as request from "../../services/FetchService";
import { staticSort } from '../../helpers/helperFunctions';
import toast from 'react-hot-toast';
import NewButton from '../Buttons/NewButton';

const NewSupportMessageModal = ({ show, onClose}) => {
    const MOBILE = useIsMobile();
    const { t } = useTranslation();
    const [deviceList, setDeviceList] = useState()
    const [selectedDevice, setSelectedDevice] = useState(-1)
    const [message, setMessage] = useState("")
    const [messageSent, setMessageSent] = useState(false)

    const handleClose = () => {
        onClose()
      //  setShow(false)
    }
 
    const getDevices = () => {
        if(!show) return;
        request.get("devices/list").then((response) => {
            //setIssueList(response.data.issues);
            let sorted = staticSort(response.data?.devices, "name")
            setDeviceList(sorted);
            //setValid(response.data.valid)
        }); 
    }

    useEffect(() => {
       // getDevices()
        getDevices()
    }, [show])

    const sendMessage = async () => {
        if(!selectedDevice || selectedDevice === -1){
            toast.error(t("toast.no_device_selected"))
            return
        }
        if(!message || message === ""){
            toast.error(t("toast.no_message"))
            return
        }
        let data = {
            deviceid: parseInt(selectedDevice),
            message
        }
        request.post("", "account/support/tickets/create", data).then((response) => {
            if(response.data.successful){
                toast.success(t("toast.sent"))
                onClose()
                setMessageSent(true)
            }
		}); 
    }
    
    
    return(
        <>
        <Dialog fullWidth={MOBILE ? true : false} open={show} onClose={handleClose}>
            <Card className="settings-dialog d-flex flex-column">
                <div className="w-100 h-100">
                    <div className="p-3 grey-blue">
                        <div className="d-flex flex-row justify-content-between align-items-center">
                            <div className='d-flex align-items-center'>
                                <h3 className="">{t("settings.new_message")}</h3>
                            </div>
                            <img className="cursor-pointer" src={icons.close_gray} onClick={() => onClose()} alt="..." /> 
                        </div>
                        <p className="grey-blue py-3">{t("settings.new_ticket_desc")}</p>
                        <div className="d-flex flex-column flex-fill w-100 mb-3">
                            <p className="bold">{t("settings.device")}</p>


                            <div className="select-wrap w-100">
                                <select value={selectedDevice} onChange={(e) => setSelectedDevice(e.target.value)} className="bg-light-grey grey-blue form-control text-truncate p-3 rounded24">
                                    <option value="">{t("settings.select")}</option>
                                    {deviceList && deviceList.map((device, index) => {
                                        return(
                                            <option key={index} value={device.id}>{device.name}</option>
                                        )
                                    })}
                                </select>
                            </div>
                        </div>
                        <div className="d-flex flex-column mt-3">
                            <p className="bold">{t("settings.message")}</p>
                            <textarea rows={5} onChange={(event) => setMessage(event.target.value)} className="pb-3 form-control text-area-boy bg-light-grey rounded24"  />    
                        </div>
                        <div className="d-flex flex-row justify-content-between align-items-center mt-4">
                            <NewButton onClick={() => onClose()} className="bg-grey p-3 rounded24 w-100 dark-grey me-2 body bold">{t("settings.cancel")}</NewButton>
                            <NewButton onClick={() => sendMessage()} className={`bg-gradient p-3 rounded24 w-100 white body bold ms-2 ${messageSent ? "disabled" : ""}`}>{messageSent ? t("settings.sent") : t("settings.send")}</NewButton>
                        </div>
                    </div>
                </div>
            </Card>
        </Dialog>
        </>
    )
}

export default NewSupportMessageModal;